import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, vModelText as _vModelText, withDirectives as _withDirectives, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, withModifiers as _withModifiers } from "vue";
const _hoisted_1 = { class: "min-h-screen flex flex-col justify-center py-12 sm:px-6 lg:px-8 text-slate-300 bg-slate-900" };
const _hoisted_2 = {
    id: "login",
    class: "admin-content min-h-full flex flex-col justify-center py-12 sm:px-6 lg:px-8"
};
const _hoisted_3 = {
    href: "#main_content",
    name: "main_content",
    tabindex: "-1"
};
const _hoisted_4 = ["src", "alt"];
const _hoisted_5 = {
    role: "main",
    class: "mt-8 px-6 sm:mx-auto sm:w-full sm:max-w-lg"
};
const _hoisted_6 = { class: "bg-white py-8 px-4 shadow rounded-lg sm:px-10 text-slate-700 shadow-lg show" };
const _hoisted_7 = { class: "font-medium text-xl text-slate-900 mb-6" };
const _hoisted_8 = {
    key: 0,
    class: "error-message mb-4"
};
const _hoisted_9 = {
    key: 0,
    class: "success-message"
};
const _hoisted_10 = {
    key: 0,
    class: "input-error-message"
};
const _hoisted_11 = {
    key: 0,
    class: "input-error-message"
};
const _hoisted_12 = { class: "mt-2" };
const _hoisted_13 = {
    key: 0,
    class: "input-error-message"
};
const _hoisted_14 = { class: "mt-2" };
const _hoisted_15 = {
    key: 0,
    class: "input-error-message"
};
const _hoisted_16 = { class: "flex items-center justify-between mt-2" };
const _hoisted_17 = { class: "text-sm" };
const _hoisted_18 = { class: "text-sm text-center mt-6" };
const _hoisted_19 = ["href"];
const _hoisted_20 = ["href"];
export function render(_ctx, _cache, $props, $setup, $data, $options) {
    const _component_router_link = _resolveComponent("router-link");
    return (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createElementVNode("section", _hoisted_2, [
            _createElementVNode("a", _hoisted_3, [
                _createElementVNode("img", {
                    src: _ctx.asset('img/logo.svg'),
                    alt: _ctx.app.name,
                    class: "mx-auto"
                }, null, 8, _hoisted_4)
            ]),
            _createElementVNode("main", _hoisted_5, [
                _createElementVNode("div", _hoisted_6, [
                    _createElementVNode("h1", _hoisted_7, "Reset Your " + _toDisplayString(_ctx.app.name) + " Password", 1),
                    (_ctx.authentication.noFieldErrors())
                        ? (_openBlock(), _createElementBlock("p", _hoisted_8, _toDisplayString(_ctx.authentication.getErrorMessage()), 1))
                        : _createCommentVNode("", true),
                    _createElementVNode("form", {
                        class: "admin-form space-y-6",
                        action: "#",
                        method: "post",
                        autocomplete: "off",
                        onSubmit: _cache[2] || (_cache[2] = _withModifiers(($event) => (_ctx.authentication.resetPassword()), ["prevent"]))
                    }, [
                        _cache[7] || (_cache[7] = _createElementVNode("p", null, " Enter a new password for your account. ", -1)),
                        (_ctx.authentication.successful())
                            ? (_openBlock(), _createElementBlock("p", _hoisted_9, _toDisplayString(_ctx.authentication.getSuccessMessage()), 1))
                            : _createCommentVNode("", true),
                        _createElementVNode("div", null, [
                            (_ctx.authentication.fieldHasErrors('email'))
                                ? (_openBlock(), _createElementBlock("p", _hoisted_10, _toDisplayString(_ctx.authentication.getFieldError('email')), 1))
                                : _createCommentVNode("", true)
                        ]),
                        _createElementVNode("div", null, [
                            (_ctx.authentication.fieldHasErrors('token'))
                                ? (_openBlock(), _createElementBlock("p", _hoisted_11, _toDisplayString(_ctx.authentication.getFieldError('token')), 1))
                                : _createCommentVNode("", true)
                        ]),
                        _createElementVNode("div", null, [
                            _cache[3] || (_cache[3] = _createElementVNode("label", { for: "password" }, "Password", -1)),
                            _createElementVNode("div", _hoisted_12, [
                                _withDirectives(_createElementVNode("input", {
                                    id: "password",
                                    name: "password",
                                    type: "password",
                                    autocomplete: "off",
                                    required: "",
                                    "aria-required": "true",
                                    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event) => ((_ctx.authentication.data.password) = $event))
                                }, null, 512), [
                                    [_vModelText, _ctx.authentication.data.password]
                                ])
                            ]),
                            (_ctx.authentication.fieldHasErrors('password'))
                                ? (_openBlock(), _createElementBlock("p", _hoisted_13, _toDisplayString(_ctx.authentication.getFieldError('password')), 1))
                                : _createCommentVNode("", true)
                        ]),
                        _createElementVNode("div", null, [
                            _cache[4] || (_cache[4] = _createElementVNode("label", { for: "password" }, "Confirm Password", -1)),
                            _createElementVNode("div", _hoisted_14, [
                                _withDirectives(_createElementVNode("input", {
                                    id: "password_confirmation",
                                    name: "password_confirmation",
                                    type: "password",
                                    autocomplete: "off",
                                    required: "",
                                    "aria-required": "true",
                                    "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event) => ((_ctx.authentication.data.password_confirmation) = $event))
                                }, null, 512), [
                                    [_vModelText, _ctx.authentication.data.password_confirmation]
                                ])
                            ]),
                            (_ctx.authentication.fieldHasErrors('password'))
                                ? (_openBlock(), _createElementBlock("p", _hoisted_15, _toDisplayString(_ctx.authentication.getFieldError('password')), 1))
                                : _createCommentVNode("", true)
                        ]),
                        _cache[8] || (_cache[8] = _createElementVNode("div", null, [
                            _createElementVNode("button", {
                                type: "submit",
                                class: "w-full"
                            }, "Proceed")
                        ], -1)),
                        _createElementVNode("nav", _hoisted_16, [
                            _cache[6] || (_cache[6] = _createElementVNode("div", { class: "flex-1" }, " ", -1)),
                            _createElementVNode("div", _hoisted_17, [
                                _createVNode(_component_router_link, { to: { name: 'login' } }, {
                                    default: _withCtx(() => [...(_cache[5] || (_cache[5] = [
                                            _createTextVNode(" Return to Sign In ", -1)
                                        ]))]),
                                    _: 1
                                })
                            ])
                        ])
                    ], 32)
                ])
            ]),
            _createElementVNode("footer", _hoisted_18, [
                _createElementVNode("p", null, [
                    _createTextVNode(_toDisplayString(_ctx.app.name) + " " + _toDisplayString(_ctx.app.version) + " © ", 1),
                    _createElementVNode("a", {
                        href: _ctx.app.copyright.url,
                        class: "alt",
                        target: "_blank"
                    }, _toDisplayString(_ctx.app.copyright.name), 9, _hoisted_19),
                    _cache[9] || (_cache[9] = _createTextVNode(". All rights reserved. ", -1))
                ]),
                _createElementVNode("p", null, [
                    _cache[10] || (_cache[10] = _createTextVNode(" Unauthorised access is not permitted. ", -1)),
                    _createElementVNode("a", {
                        href: _ctx.app.status_url,
                        class: "alt",
                        target: "_blank"
                    }, "System Status", 8, _hoisted_20)
                ])
            ])
        ])
    ]));
}
